/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { StorageModule } from "@vlinder-web/storage-module-react";

const storageService = StorageModule.getInstance();
const DEFAULT_APP_CONFIG = storageService.get("appConfig", "session");



export const CONTACT = {
    title: "Contact Asset Creator",
    subject: "Contact Asset Creator",
    url: DEFAULT_APP_CONFIG?.organization?.contactUs,
    appId:DEFAULT_APP_CONFIG?.organization?.appId,
    action: "contact_request",
    id: "contact",

}